module.exports = __webpack_public_path__ + "img/dots.379f0f2.png";